import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardsState } from '../../_reducers/settings/dashboards.reducers';
const getDashboards = createFeatureSelector<DashboardsState>('dashboards');


export const getAllDashboardsLoading = createSelector(
  getDashboards,
  (state: DashboardsState) => state.dashboardsLoading
);

export const getDatabaseReportsLoading = createSelector(
  getDashboards,
  (state: DashboardsState) => state.databaseReportsLoading
);

export const getSummaryReportsLoading = createSelector(
  getDashboards,
  (state: DashboardsState) => state.summaryReportsLoading
);

export const getSummaryFieldsLoading = createSelector(
  getDashboards,
  (state: DashboardsState) => state.summaryFieldsLoading
);

export const getReportsByTypeLoading = createSelector(
  getDashboards,
  (state: DashboardsState) => state.reportsLoading
);
/**
 * Get all dashboards
 */

export const getAllDashboards = createSelector(
  getDashboards,
  (state: DashboardsState) => state.dashboards
);
/**
 * Get  dashboard
 */

export const getDashboardDetail = createSelector(
  getDashboards,
  (state: DashboardsState) => state.dashboardDetails
);

/**
 * Get all Summary Fields
 */
export const getSummaryFields = createSelector(
  getDashboards,
  (state: DashboardsState) => state.summaryFields
);

/**
 * Get all Database Reports
 */
export const getDatabaseReports = createSelector(
  getDashboards,
  (state: DashboardsState) => state.databaseReports
);

/**
 * Get summary field value
 */
export const getSummaryFieldValue = createSelector(
  getDashboards,
  (state: DashboardsState) => state.summaryFieldValue
);

/**
 * Get all Summary Reports
 */
export const getSummaryReports = createSelector(
  getDashboards,
  (state: DashboardsState) => state.summaryReports
);

/**
 * Get Reports by type
 */
 export const getReportsByType = createSelector(
  getDashboards,
  (state: DashboardsState) => state.reports
);

/**
 * Get Reports by type
 */
 export const getError = createSelector(
  getDashboards,
  (state: DashboardsState) => state.error
);
 export const getDashboardOprations = createSelector(
  getDashboards,
  (state: DashboardsState) => state.operations
);
